import "bootstrap/dist/css/bootstrap.min.css"
import React from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import AppShell from "src/components/layout/AppShell"
import { selectRol } from "src/redux/slices/authSlice"
import { getLayoutStrategy } from "../strategies"
import "src/assets/css/scrollbar.css"

const DashboardLayout = ({ children }) => {
  const rol = useSelector(selectRol)
  const { Brand, End, Effects } = getLayoutStrategy(rol)

  return (
    <AppShell brand={<Brand />} end={<End />}>
      <Effects />
      {children}
    </AppShell>
  )
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
}

DashboardLayout.defaultProps = {
  children: "",
}

export default DashboardLayout
